import { KpiService } from 'src/app/services/kpi/kpi.service';
import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
})
export class ListComponent implements OnInit {
  IndicatorId
  categoryId
  @Input()participants 
  @Input()label 
  image = '../../../../../../../../assets/img/default-user.jpg'

  constructor(private kpiService : KpiService) { }

  async ngOnInit() {
    const ids = (this.participants as any[]).map((data)=> {return data.uid})
      
    const images = await this.getImage(ids)
    this.participants.forEach(element => {
      const image = images.find((data)=> data.id == element.uid).image
      element.image = image ? image : this.image
    })
  }

  async getImage(listIds : string[]): Promise <any[]>{
    return new Promise ((resolve,reject)=>{
      this.kpiService.getImagesUser(listIds).then((result) => {
        resolve(result)
       }).catch((err) => {
        console.error(err);
       });
    })
     
  }





}
